/* eslint-disable prettier/prettier */
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { ThemeContext } from 'styled-components'

// ui-kit
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { PopOverComponent } from '@navent-jobs/ui-kit/components/pop-over'
import Text from '@navent-jobs/ui-kit/components/text'

// components
import CheckSalario from './components/CheckSalario'
import LabelSalario from './components/LabelSalario'
import PopOverImg from '../../../../../../../assets/images/postulaciones/bombilla.svg'
import PopOverImgZona from '../../../../../../../assets/images/postulaciones/bombilla-zona.svg'

// mixins
import { InputSalario, ButtonPostularme, HelperTextSalario, MessaggeError, LinkCustom, Container } from './mixins'
import { IS_ZONA_JOBS, SITE_ID } from '../../../../../../../constants'
import features from '../../../../../../../constants/features-per-country'

const promedioSalarial = features[SITE_ID || 'BMAR'].promedioSalarial.enabled

const Component = ({
  isLoading,
  isMobile,
  productoLookAndFeel,
  actualizarSalario,
  setActualizarSalario,
  salarioBrutoPretendido,
  setSalarioPretendido,
  salarioRequerido,
  handlePostularme,
  showComponentSalarioPretendido,
  aviso,
  postulacionRapida,
}) => {
  const [showPopover, setShowPopover] = useState(false)
  const { t } = useTranslation()
  const preTabletLandscapeMinWidth = 992
  const preMobileMinWidth = 575
  const showErrorUnderInput = window.outerWidth >= preTabletLandscapeMinWidth || window.outerWidth <= preMobileMinWidth
  const { colors } = useContext<{ colors }>(ThemeContext)

  const { register, errors, handleSubmit, control } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  let maskOptions: any = t('currencyMask', { returnObjects: true })

  if (maskOptions === 'currencyMask') {
    maskOptions = {
      decimalSymbol: ',',
      prefix: '',
    }
  }

  const SalarioComponent = () =>
    promedioSalarial && aviso.area.stringId ? (
      <>
        {' '}
        <Text size="xs" variant="gray60" as="span">
          {t('fichaAviso.inputSalario.helperText.salarioPromedioPrimero')}
        </Text>
        <LinkCustom
          key="salario-pretendido-label"
          href={`/salarios/${aviso?.area?.stringId}`}
          linkoptions={{ variant: 'darken', type: 'link', target: '_blank' }}
        >
          {t('fichaAviso.inputSalario.helperText.salarioPromedioLink')}
        </LinkCustom>
        <Text size="xs" variant="gray60" as="span">
          {t('fichaAviso.inputSalario.helperText.salarioPromedioSegundo')}
        </Text>
      </>
    ) : (
      <></>
    )

  const ErrorComponent = () =>
    errors.salarioPretendido?.type !== 'required' ? (
      <HelperTextSalario>
        <Text size="xs" variant="gray60">
          {t('fichaAviso.inputSalario.helperText.default')}
          <SalarioComponent />
        </Text>
      </HelperTextSalario>
    ) : (
      <></>
    )

  return (
    <PopOverComponent
      id="salary-popover"
      visible={showPopover}
      onClose={() => setShowPopover(false)}
      content={<LabelSalario />}
      imgSrc={IS_ZONA_JOBS ? PopOverImgZona : PopOverImg}
      arrowProps="upperCenter"
      fullwidth
    >
      <form id="form-salario-pretendido" onSubmit={handleSubmit(handlePostularme)}>
        <Row>
          {showComponentSalarioPretendido && (
            <>
              <Col sm={12} lg={{ size: 12, order: 2 }}>
                <CheckSalario setActualizarSalario={setActualizarSalario} actualizarSalario={actualizarSalario} />
                {!isMobile && <LabelSalario />}
              </Col>

              <Col setPaddingR sm={7} lg={{ size: 12, order: 1 }}>
                <InputSalario
                  id="salarioPretendido"
                  type="number"
                  name="salarioPretendido"
                  placeholder={
                    isMobile
                      ? t('fichaAviso.postularBar.sueldoPretendido')
                      : t('fichaAviso.postularBar.ingresaSueldoPretendido')
                  }
                  value={salarioBrutoPretendido}
                  onChange={event => {
                    setSalarioPretendido(
                      event.target.value
                        .slice(maskOptions.prefix.length)
                        .split(maskOptions.decimalSymbol)[0]
                        .replace(/\D+/g, '')
                    )
                  }}
                  onFocus={() => isMobile && showComponentSalarioPretendido && setShowPopover(true)}
                  fieldOptions={{
                    variant: 'darken',
                    before: (
                      <Icon
                        name={(maskOptions && maskOptions.icon) || 'icon-light-money'}
                        color={colors.primary.lighten}
                        size="24"
                      />
                    ),
                  }}
                  maskOptions={maskOptions}
                  ref={register}
                  rules={{
                    required: {
                      value: salarioRequerido,
                      message: (
                        <MessaggeError>
                          <Text size="xs" variant="danger">
                            {t('fichaAviso.inputSalario.helperText.error')}
                          </Text>
                        </MessaggeError>
                      ),
                    },
                  }}
                  errors={errors}
                  control={control}
                  noBottomMargin
                />

                {showErrorUnderInput && <ErrorComponent />}
              </Col>
            </>
          )}

          <Col sm={showComponentSalarioPretendido ? { size: 5 } : { size: 12 }} lg={{ size: 12, order: 3 }}>
            <ButtonPostularme
              buttonoptions={{ variant: 'primary', block: true, size: 'medium' }}
              productoLookAndFeel={productoLookAndFeel}
              form="form-salario-pretendido"
              type="submit"
              disabled={isLoading}
              isLoading={isLoading}
            >
              {postulacionRapida ? (
                <Container>
                  <Icon name="icon-light-flash-on" color={colors.gray0} />
                  {t('fichaAviso.postulacionRapida')}
                </Container>
              ) : (
                t('fichaAviso.postularme')
              )}
            </ButtonPostularme>
          </Col>
        </Row>
        {!showErrorUnderInput && <ErrorComponent />}
      </form>
    </PopOverComponent>
  )
}

export default Component
